import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  CircularProgress,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import ArticleItem from "../components/article-item";
import HomeNavbar from "../components/home-nav-bar";

function Articles() {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios
      .get("https://api.wajls.com/client/v1/fetch_articles.php?limit=*")
      .then((response) => {
        setArticles(response.data);
        setFilteredArticles(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load articles data.");
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const filtered = articles.filter((article) => {
      return (
        article.title?.toLowerCase().includes(query) ||
        article.authors?.toLowerCase().includes(query) ||
        article.volume?.toLowerCase().includes(query)
      );
    });
    setFilteredArticles(filtered);
  }, [searchQuery, articles]);

  return (
    <Box sx={{ mt: 2, minHeight: "100vh" }}>
      <HomeNavbar/>

      <Box sx={{ p: 1, maxWidth: 'lg', margin: 'auto' }}>

      <TextField
          fullWidth
          placeholder="Search by title, author, or volume"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ mb: 3, backgroundColor: "white", borderRadius: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : filteredArticles.length === 0 ? (
          <Typography color="textSecondary">No articles found.</Typography>
        ) : (
          <Box>
            {filteredArticles.map((article) => (
              <ArticleItem
                key={article.id}
                title={article.title}
                url={article.url}
                authors={article.authors}
                journal_name={article.journal_name}
                volume={article.volume}
                issue={article.issue}
                publish_date={article.publish_date}
                type="main"
              />
            ))}
          </Box>
        )}
        
      </Box>
     
    </Box>
  );
}

export default Articles;
